/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import PropTypes from 'prop-types';
import {ImageType} from "./aem.model";

export const ReferencePageType = Object.assign({
    id: PropTypes.string,
    title: PropTypes.string,
    referenceTitle: PropTypes.string,
    image: PropTypes.shape(ImageType),
    link: PropTypes.string
});

export const ProductType = Object.assign({
    skuImage: PropTypes.shape(ImageType),
    isObsolete: PropTypes.bool,
    hasPrice: PropTypes.bool,
}, ReferencePageType);

export const PromotionType = {
    longPromotionText: PropTypes.string,
    promoCode: PropTypes.string,
    shortPromotionText: PropTypes.string,
};
